import React, {useContext, useEffect, useState} from 'react';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from'@material-ui/core/CircularProgress';

import UsersList from '../Users/UsersList'
import styles from './AdminsPage.module.css';

import _firebaseContext from '../../contexts/firebaseContext';
import _appContext from '../../contexts/appContext';

export default function AdminsPage() {
    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);
    const [isUserUpdateLoading, setIsUserUpdateLoading] = useState(false);
    const [searchRequest, setSearchRequest] = useState('');

    useEffect(() => {
        setIsUserUpdateLoading(firebaseContext.data.fetchingState.updateUser);
    }, [firebaseContext.data.fetchingState.updateUser]);

    useEffect(() => {
        const fetchingState = firebaseContext.data.fetchingState['admins'];

        if (fetchingState) {
            appContext.startLoading();
        } else {
            appContext.endLoading();
        }
    });

    useEffect(() => {
        firebaseContext.startAdminsListener()

        return () => {
            firebaseContext.closeAdminsListener()
        }
    }, []);

    const searchRequestHandler = searchValue => {
        setSearchRequest(searchValue);
    }

    return (
        <>
            <Typography variant="h4" component="h1" className={styles.page__title}>
                Страница управления стримерами и админами
            </Typography>
            <Divider/>
            <UsersList
                type="admins"
                searchRequest={searchRequest}
                searchRequestHandler={searchRequestHandler}
            />
            {
                isUserUpdateLoading &&
                <Backdrop style={{zIndex: 10000}} open={true}>
                    <CircularProgress style={{color: '#FFF'}}/>
                </Backdrop>
            }
        </>
    );
}
